import RaceCartItemMixin from '../../../../../components/_mixins/race-cart-item'

export default {
  name: 'ninja-cart-item',
  settings: 'page.cart',
  translations: 'page.cart',
  mixins: [RaceCartItemMixin]
}
